import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierQuotationLine, SupplierQuotationLineCreate, SupplierQuotationLineFilter } from '../data/supplierQuotationLine';

export function createSupplierQuotationLineService(client: AxiosInstance) {
  return createCrudService<SupplierQuotationLine, SupplierQuotationLineCreate, SupplierQuotationLineFilter>(
    client,
    '/purchase/SupplierQuotationLine',
    'id',
  );
}

export type SupplierQuotationLineService = CrudService<SupplierQuotationLine, SupplierQuotationLineCreate, SupplierQuotationLineFilter>;
